import React from 'react'

export interface Props {
  text: string
}
const style: React.CSSProperties = { padding: '0', margin: '0' }

const MultiLineText: React.FC<Props> = (props: Props) => {
  const text = props.text ?? ''
  if (text.length < 1) return null
  const newText = text.split('\n').map((str, index) => (
    <p key={index} style={style}>
      {str}
    </p>
  ))

  return <>{newText}</>
}

export default MultiLineText
